/* Pearl grading page: pearl-type tabs, hash deep links, and the
   mobile scroll cue on the grade tables. */
(function () {
  var root = document.querySelector('.ppg');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('.ppg-tab'));

  function show(tab, focus) {
    tabs.forEach(function (t) {
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      var on = t === tab;
      t.setAttribute('aria-selected', String(on));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { show(t); });
    t.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      if (n) { e.preventDefault(); show(n, true); }
    });
  });

  // Once a table has been scrolled sideways the edge fade has done
  // its job, so drop it rather than leaving it over the content.
  root.querySelectorAll('.ppg-tablewrap').forEach(function (wrap) {
    wrap.addEventListener('scroll', function () {
      if (wrap.scrollLeft > 4 && wrap.parentElement) {
        wrap.parentElement.classList.add('ppg-scrolled');
      }
    }, { passive: true });
  });

  // A hash may name a pearl type (opens that chart) or a collapsed
  // panel (opens it, and any parent, then scrolls to it).
  function openFromHash() {
    var hash = (window.location.hash || '').replace('#', '');
    if (!hash) return;

    var tab = document.getElementById('t-' + hash);
    if (tab) {
      show(tab);
      var standards = document.getElementById('standards');
      if (standards) standards.scrollIntoView();
      return;
    }

    var el = document.getElementById(hash);
    if (!el) return;
    var node = el;
    while (node) {
      if (node.tagName === 'DETAILS') node.open = true;
      node = node.parentElement;
    }
    el.scrollIntoView();
  }

  window.addEventListener('hashchange', openFromHash);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a && a.getAttribute('href').length > 1) setTimeout(openFromHash, 0);
  });
  openFromHash();
})();
